import { useMemo } from 'react'
import { SearchCheck, AlertTriangle } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { ModListScreen } from './ModListScreen'
import { makeFetcher, MOD_STR as S, type AuditRow, type ErrorDecisionRow } from './modContentApi'

/**
 * A6.37 — Qarorlar auditi (tasodifiy tanlov). Sifat nazorati uchun tanlab olingan
 * qarorlarni qayta tekshirish (GET /admin/moderation/audit).
 */
export function DecisionAuditScreen() {
  const columns = useMemo<AdminColumn<AuditRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'decision_id', header: S.decisionId, type: 'number' },
      { key: 'original_action', header: S.originalAction, type: 'text' },
      { key: 'auditor', header: S.auditor, type: 'text' },
      { key: 'verdict', header: S.verdict, type: 'text' },
      { key: 'sampled_at', header: S.sampledAt, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<AuditRow>
      screenId="A6.37"
      title={S.audit}
      description={S.auditDesc}
      columns={columns}
      fetcher={makeFetcher<AuditRow>(
        '/admin/moderation/audit',
        'items',
        (r) => `${r.original_action} ${r.auditor} ${r.verdict}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<SearchCheck size={28} strokeWidth={1.5} />}
    />
  )
}

/**
 * A6.39 — Xato qarorlar tahlili. Bekor qilingan / to'g'rilangan qarorlar
 * (GET /admin/moderation/errors) — xato manbalarini o'rganish uchun.
 */
export function ErrorDecisionsScreen() {
  const columns = useMemo<AdminColumn<ErrorDecisionRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'decision_id', header: S.decisionId, type: 'number' },
      { key: 'original_action', header: S.originalAction, type: 'text' },
      { key: 'corrected_action', header: S.correctedAction, type: 'text' },
      { key: 'reason', header: S.reason, type: 'longtext' },
      { key: 'moderator', header: S.moderator, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<ErrorDecisionRow>
      screenId="A6.39"
      title={S.errors}
      description={S.errorsDesc}
      columns={columns}
      fetcher={makeFetcher<ErrorDecisionRow>(
        '/admin/moderation/errors',
        'items',
        (r) => `${r.original_action} ${r.corrected_action} ${r.moderator}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<AlertTriangle size={28} strokeWidth={1.5} />}
    />
  )
}
